import type {
	AIFeatureRequestEnvelopeActionRankingRequest,
	RovoActionRankingResponseSummary,
} from '@atlassian/convo-ai-api';

const ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_FEATURE_RECOMMENDATION';

const CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';

type FetchRankedActionsProps = {
	triggerId: string;
	siteId: string;
	featureView: string;
};

export const fetchRankedActions = async ({
	triggerId,
	siteId,
	featureView,
}: FetchRankedActionsProps): Promise<RovoActionRankingResponseSummary | undefined> => {
	const request: AIFeatureRequestEnvelopeActionRankingRequest = {
		ai_feature_input: {
			triggers: [
				{
					trigger_id: triggerId,
					trigger_details: {
						feature_view: featureView,
					},
					trigger_type: ROVO_BUTTON_TRIGGER_TYPE,
				},
			],
		},
	};
	const response = await fetch(CONVO_AI_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'X-Product': 'confluence',
			'X-Experience-Id': 'proactive-ai-ranked-actions',
			user_id: triggerId,
			cloud_id: siteId,
			product: 'confluence',
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Error fetching action rankings: ${response.statusText}`);
	}
	const data = await response.json();
	const content = data?.ai_feature_output;
	if (!content) {
		return undefined;
	}
	return content as RovoActionRankingResponseSummary;
};
